import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { DashboardWizardForm } from '../../containers/dashboard-wizard-form'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { DashboardShape } from '../../../../prop-types'
import * as PropTypes from 'prop-types'
import { dashboardOperations } from '../../../../state/ducks/dashboards'
import { connect } from 'react-redux'
import { Session } from '../../../../state/utils/session'

class DashboardEditorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.props.getDashboard(this.props.match.params.dashboard_id)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_DASHBOARDS_PATH.replace(':client_id', this.state.session.getClientSession())}
                    >
                        Dashboards
                    </NavLink>
                </li>
                <li>Edit Dashboard</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={this.props.dashboard.name}
                        subTitle={'Edit Dashboard'}
                        paths={this.renderHeaderPaths}
                    />
                    <DashboardWizardForm
                        dashboard={this.props.dashboard}
                        isEditor={true}
                    />
                </PageContainerLayout>
            </>
    )
  }
}

// Set propTypes
DashboardEditorPage.propTypes = {
  dashboard: DashboardShape,
  getDashboardErrorResponse: PropTypes.object
}

// Set defaultProps
DashboardEditorPage.defaultProps = {
  dashboard: {},
  getDashboardErrorResponse: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  dashboard: state.dashboards.getDashboardReducer.data,
  isLoading: state.dashboards.getDashboardReducer.loading,
  getDashboardErrorResponse: state.dashboards.getDashboardReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  getDashboard: dashboardOperations.get
}

// Export Class
const _DashboardEditorPage = connect(mapStateToProps, mapDispatchToProps)(DashboardEditorPage)
export { _DashboardEditorPage as DashboardEditorPage }
